<template>
  <div class="multi-mode-dispatch">
    <!-- 顶部提示 -->
    <div class="tip"><i class="el-icon-info" style="margin-right: 5px;"></i>此项为付费功能</div>


    <div class="multi-container">
      <div class="switch-container">
        <div class="switch-label">多模式下单
          <el-switch
            v-model="isActivated"
            @change="handleSwitchChange"
            style="margin-left: 5px;"
          />
        </div>
        <el-button
          type="primary"
          size="small"
          @click="openFeeModal"
          v-if="effectiveDate == ''"
        >
          开通
        </el-button>
        <el-button
          type="primary"
          size="small"
          @click="renewService"
          v-else
        >
          续费
        </el-button>
      </div>
      <!-- 状态信息 -->
      <div class="status-info">
        <div class="status-text" :class="{ active: isActivated }">
          {{ isActivated ? '已开启' : '未开启' }}
        </div>
        <div class="date-info">
          <div>
              开通时间：{{ effectiveDate || '无' }}
          </div>
          <div>
              到期时间：{{ expiryDate || '无' }}
          </div>
          <div>

          </div>
        </div>
      </div>
    </div>



    <!-- 功能示例 -->
    <div class="function-example">
      <h3>功能示例</h3>
      <div class="map-container">
        <img src="@/assets/multiMode.png"/>
      </div>
    </div>

    <!-- 收费标准弹窗 -->
    <el-dialog
      title="多模式下单收费标准 (元)"
      :visible.sync="feeModalVisible"
      width="666px"
      center
      :show-close="false"
    >
      <div class="fee-options">
        <div
          v-for="(item, index) in feeList"
          :key="index"
          class="fee-option"
          :class="{ selected: selectedFee === item.code }"
          @click="selectFee(item.code)"
        >
          {{ item.title }} {{ item.price }}
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeFeeModal">关闭</el-button>
        <el-button type="primary" @click="confirmPayment">
          立即充值
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
var _this;

export default {
  name: 'MultiModeDispatch',
  data() {
    return {
      isActivated: false,
      effectiveDate: '',
      expiryDate: '',
      feeModalVisible: false,
      selectedFee: '',
      feeList: [
        // { code: '3month', title: '季度', price: 1500 },
        // { code: '6month', title: '半年', price: 2000 },
        // { code: '12month', title: '全年', price: 3800 }
      ],
      cityCode: ''
    }
  },
  created() {
    _this = this;
    _this.cityCode = JSON.parse(localStorage.getItem('login')).city.city_code;
    _this.getMultiModeDetail();
  },
  methods: {
    getMultiModeDetail() {

      _this.$post('/multi_mode/detail', {
        // city_code: _this.cityCode
      })
      .then((res) => {
        console.log(res);
        if (res.code === 200) {
          _this.isActivated = res.data.status == "1";
          _this.effectiveDate = res.data.created_at || '';
          _this.expiryDate = res.data.expired_at || '';
          _this.feeList = res.data.price_list || [];
        }
      })
      .catch((err) => {
        console.error('获取多模式状态失败:', err);
      });
    },

    handleSwitchChange(value) {
      console.log(value);
      // if (value) {
      //   _this.openFeeModal();
      // } else {
      //   _this.$confirm('确定要关闭多模式派单吗？', '提示', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     type: 'warning'
      //   }).then(() => {
      //     _this.closeMultiMode();
      //   }).catch(() => {
      //     _this.isActivated = true;
      //   });
      // }
       _this.$post('/multi_mode/switch', {
            status: value ? "1" : "0"
        })
        .then((res) => {
            _this.$message.success(res.msg);
            _this.getMultiModeDetail();
        })
        .catch((err) => {
            _this.getMultiModeDetail();
        });
    },
    openFeeModal() {
      this.feeModalVisible = true;
    },
    closeFeeModal() {
      this.feeModalVisible = false;
    },
    selectFee(type) {
      console.log(type);
      this.selectedFee = type;
    },
    confirmPayment() {
      const selectedFeeInfo = _this.feeList.find(item => item.code === _this.selectedFee);

      if (!selectedFeeInfo) {
        _this.$message.error('请选择收费套餐');
        return;
      }

      _this.$confirm(`确认充值 ${selectedFeeInfo.title} 套餐，费用 ${selectedFeeInfo.price} 元？`, '支付确认', {
        confirmButtonText: '确认支付',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        _this.$post('/multi_mode/open', {
          code: _this.selectedFee,
        })
        .then((res) => {
          if (res.code === 200) {
            _this.$message.success(res.msg || '充值成功');
            _this.closeFeeModal();
            _this.getMultiModeDetail();
          } else {
            _this.$message.error(res.msg || '充值失败');
          }
        })
      }).catch(() => {});
    },
    renewService() {
      this.openFeeModal();
    }
  }
}
</script>

<style scoped>
.multi-mode-dispatch {
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  /* margin: 20px; */
}

.tip {
  color: #FF4B4B;
  padding: 10px 15px;
  font-size: 14px;
  margin-bottom: 20px;
  background: rgba(255, 75, 75, 0.1);
  border-radius: 5px;
}
.multi-container {
  margin-bottom: 24px;
  border-radius: 5px;
  border: 1px solid #EAEAEA;
}
.switch-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* margin-bottom: 24px; */
  padding: 16px;
  background: #F5F7FA;
  border-radius: 6px;
}

.switch-label {
  font-size: 16px;
  font-weight: 500;
  color: #333;
  margin-right: 12px;
}

.status-info {
  padding: 16px;
  background-color: #fff;
  border-radius: 6px;
}

.status-text {
  font-size: 16px;
  margin-bottom: 8px;
  font-weight: 500;
  color: #FF3B3B;
}

.status-text.active {
  color: #05C0AB;
}

.date-info {
  display: flex;
  justify-content: space-between;
  color: #909399;
  font-size: 14px;
  margin: 4px 0;
}

.function-example {
  margin-top: 24px;
  /* padding: 16px; */
  background-color: #fff;
  border-radius: 6px;
  border: 1px solid #e9ecef;
}

.function-example h3 {
  padding: 16px;
  background: #F5F7FA;
  /* margin-bottom: 12px; */
  font-size: 16px;
  color: #2A2A2A;
  font-weight: 400;
}

.map-container {
  width: 240px;
  height: 524px;
  margin: 30px  24px;
}

.map-container img {
  width: 100%;
  height: 100%;
}


/* 收费标准弹窗 */
.el-dialog__body {
  padding: 30px;
}

.fee-options {
  display: flex;
  justify-content: space-around;
  margin: 20px 0;
  gap: 16px;
}

.fee-option {
  padding: 25px 16px;
  border: 1px solid #ddd;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  min-width: 120px;
}

.fee-option:hover {
  background-color: #f5f7fa;
  border-color: #bdc3c7;
}

.fee-option.selected {
  background-color: #00bfa5;
  color: white;
  border-color: #00bfa5;
  box-shadow: 0 4px 12px rgba(0, 191, 165, 0.3);
}

.fee-option.selected:hover {
  background-color: #00a790;
}

.dialog-footer {
  text-align: center;
  margin-top: 24px;
}

.dialog-footer .el-button {
  padding: 10px 24px;
  font-size: 14px;
}

.dialog-footer .el-button--primary {
  background-color: #00bfa5;
  border-color: #00bfa5;
  color: white;
  border-radius: 6px;
}

.dialog-footer .el-button--primary:hover {
  background-color: #00a790;
}

/* 按钮样式优化 */
.switch-container .el-button {
  padding: 8px 16px;
  font-size: 14px;
  border-radius: 6px;
}

.switch-container .el-button--primary {
  background-color: #00bfa5;
  border-color: #00bfa5;
  color: white;
}

.switch-container .el-button--primary:hover {
  background-color: #00a790;
}
/deep/.el-dialog__header {
  background: #05C0AB;
  padding: 20px;
  font-size: 16px;
  color: #fff;
  text-align: left;

}
/deep/.el-dialog__title {
  color: #fff;
}
</style>